module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "toolbar-view"
  }, _vm._l((_vm.actions), function(action) {
    return (action.visible !== false) ? _c('md-button', {
      key: action.action,
      staticClass: "action",
      class: {
        'separator-after': action.separatorAfter, 'md-primary': action.highlight
      },
      nativeOn: {
        "click": function($event) {
          _vm.onAction(action)
        }
      }
    }, [_c('md-icon', {
      staticClass: "md-size-2x"
    }, [_vm._v("\n      " + _vm._s(action.icon) + "\n      "), _c('md-tooltip', [_vm._v(_vm._s(action.title))])], 1)], 1) : _vm._e()
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-685d0524"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ToolbarView.vue
// module id = 1012
// module chunks = 1